"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTooltip = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
exports.StyledTooltip = (0, styled_components_1.default)(wl_ui_kit_1.Popover) `
  z-index: ${wl_ui_kit_1.Z_INDEXES.MENU};
  max-width: ${(0, wl_ui_kit_1.getSizeBy)(50)};
  padding: ${(0, wl_ui_kit_1.getSizeBy)(3)};
  background: ${(0, wl_ui_kit_1.getColor)('surface')};
  border-radius: ${(0, wl_ui_kit_1.getThemeProp)('borderRadius')}px;
`;
//# sourceMappingURL=styled-tooltip.js.map